import { supportsWebp } from './supportsWebp.js'

export function getClosestWidth(width) {
  return [240, 320, 480, 640].reduce((prev, curr) => {
    const isCloser = Math.abs(curr - width) < Math.abs(prev - width)
    return isCloser ? curr : prev
  })
}

export default function getOptimisedImagesUrl(imageUrl, width) {
  const url = new URL(imageUrl)
  const imageKey = url.pathname.substr(1).replace('_512', '')
  const imageRequest = JSON.stringify({
    key: imageKey,
    edits: {
      toFormat: supportsWebp() ? 'webp' : undefined,
      resize: {
        width,
      },
    },
  })
  const imagePath = btoa(imageRequest)
  return `${__CDN_BASE__}/${imagePath}`
}

export function getSrcSetUrls(thumbnail, srcSets) {
  return srcSets
    .map((width) => {
      const url = getOptimisedImagesUrl(thumbnail, width)
      return `${url} ${width}w`
    })
    .join()
}

export function formatSizes(sizes) {
  if (sizes === null) {
    return '0px'
  }

  if (typeof sizes !== 'number') {
    return sizes
  }
  return `${sizes}px`
}
